import { getCookie } from "./utils";
import { openIdb } from "./storageManager";

const { get, set, clear } = openIdb(
  "cache_processor",
  "items",
  1,
  "mykitems-" + getCookie("currentUser"),
  true
);

export const getCache = async (
  key,
  callback = null,
  param = {},
  expiry = 300
) => {
  let content = await get(key);
  if (typeof content == "undefined" || content === null) {
    if (callback !== null) {
      content = await callback(param);
    } else {
      content = {};
    }
    await set(key, content, expiry);
    return content;
  } else {
    return content;
  }
};

export const setCache = async (key, content = {}) => {
  return await set(key, content);
};

export const clearCache = async () => {
  return await clear();
}